import mermaid from "mermaid";
import { DEFAULT_FONT_SIZE, MERMAID_CONFIG } from "./constants.js";
import { encodeEntities } from "./utils.js";
import { parseMermaidFlowChartDiagram } from "./parser/flowchart.js";
import { parseMermaidSequenceDiagram } from "./parser/sequence.js";
import { parseMermaidClassDiagram } from "./parser/class.js";
// Fallback to Svg
const convertSvgToGraphImage = (svgContainer) => {
    // Extract SVG width and height
    // TODO: make width and height change dynamically based on user's screen dimension
    const svgEl = svgContainer.querySelector("svg");
    if (!svgEl) {
        throw new Error("SVG element not found");
    }
    const rect = svgEl.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;
    // Set width and height explictly since in firefox it gets set to 0
    // if the width and height are not expilcitly set
    // eg in some cases like er Diagram, gnatt, width and height is set as 100%
    // which sets the dimensions as 0 in firefox and thus the diagram isn't rendered
    svgEl.setAttribute("width", `${width}`);
    svgEl.setAttribute("height", `${height}`);
    // Convert SVG to image
    const mimeType = "image/svg+xml";
    const decoded = unescape(encodeURIComponent(svgEl.outerHTML));
    const base64 = btoa(decoded);
    const dataURL = `data:image/svg+xml;base64,${base64}`;
    const graphImage = {
        type: "graphImage",
        mimeType,
        dataURL,
        width,
        height,
    };
    return graphImage;
};
export const parseMermaid = async (definition, config = MERMAID_CONFIG) => {
    mermaid.initialize({
        ...MERMAID_CONFIG,
        ...config,
        themeVariables: {
            fontSize: `${DEFAULT_FONT_SIZE}px`,
        },
    });
    // Parse the diagram definition using Mermaid v11 API
    const diagram = await mermaid.mermaidAPI.getDiagramFromText(encodeEntities(definition));
    // Render the SVG diagram to be able to query DOM elements
    const { svg } = await mermaid.render("mermaid-to-excalidraw", definition);
    // Append SVG to DOM temporarily to allow querying element dimensions/positions
    const svgContainer = document.createElement("div");
    svgContainer.setAttribute("style", `opacity: 0; position: relative; z-index: -1;`);
    svgContainer.innerHTML = svg;
    svgContainer.id = "mermaid-diagram";
    document.querySelector("#mermaid-diagram")?.remove();
    document.body.appendChild(svgContainer);
    let data;
    try {
        switch (diagram.type) {
            case "flowchart-v2":
            case "graph": {
                data = parseMermaidFlowChartDiagram(diagram.db, svgContainer);
                break;
            }
            case "sequence": {
                data = parseMermaidSequenceDiagram(diagram, svgContainer);
                break;
            }
            case "class":
            case "classDiagram": {
                data = parseMermaidClassDiagram(diagram, svgContainer);
                break;
            }
            default: {
                data = convertSvgToGraphImage(svgContainer);
            }
        }
    }
    catch (error) {
        console.error("Error processing Mermaid diagram:", error);
        data = convertSvgToGraphImage(svgContainer);
    }
    finally {
        svgContainer.remove();
    }
    return data;
};
//# sourceMappingURL=parseMermaid.js.map